export default {
  tab: {
    'rendering-engine': 'Vykresľovací engine',
    'barcode-scanner': 'Skener čiarových kódov',
    'api-explorer': 'Prieskumník API',
  },
};
